const selectMapper = (data) => {
  let responseMapper = []
  responseMapper = {
    error: data.error ?? '',
    message: data.message ?? '',
    variant: data.variant ?? '',
    data: data.data ?? ''
  }
  return responseMapper
}

const responseMapper = (data) => {
  let responseMapper = []
  responseMapper = {
    error: data.error ?? '',
    message: data.message ?? '',
    variant: data.variant ?? ''
  }
  return responseMapper
}

const functionsMapper = {
  responseMapper,
  selectMapper
}

export default functionsMapper
